import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip as HeroTooltip } from '@heroui/react';
export const Tooltip = (props) => {
    return _jsx(HeroTooltip, { ...props });
};
export default Tooltip;
//# sourceMappingURL=Tooltip.js.map